module.exports = __webpack_public_path__ + "img/ndz.430c6bdd.svg";